"use strict";

exports.__esModule = true;
exports.formatDurationToParts = exports.formatDuration = exports["default"] = exports.TIMER_FORMAT = exports.FormattedDuration = exports.EXTENDED_FORMAT = void 0;
var _FormattedDuration = _interopRequireDefault(require("./FormattedDuration"));
exports.FormattedDuration = _FormattedDuration["default"];
exports["default"] = _FormattedDuration["default"];
var _formatDuration = require("./formatDuration");
exports.formatDuration = _formatDuration.formatDuration;
exports.formatDurationToParts = _formatDuration.formatDurationToParts;
exports.EXTENDED_FORMAT = _formatDuration.EXTENDED_FORMAT;
exports.TIMER_FORMAT = _formatDuration.TIMER_FORMAT;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }